/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {VersionResponse} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Returns server version + release identifier. Cheap, side-effect-free.
 */
export type getVersionResponse200 = {
  data: VersionResponse
  status: 200
}

export type getVersionResponseSuccess = getVersionResponse200 & {
  headers: Headers
}
export type getVersionResponse = getVersionResponseSuccess

export const getGetVersionUrl = () => {
  return `/version`
}

export const getVersion = async (options?: RequestInit): Promise<getVersionResponse> => {
  return customFetch<getVersionResponse>(getGetVersionUrl(), {
    ...options,
    method: 'GET',
  })
}
